module.exports = __webpack_public_path__ + "img/115002.f30568dc.png";